package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CalendarBox
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.PaintIcon
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.select_days.SelectDays
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun TemplateInfoDetail(
    windowSizeMode: WindowSizeModeEnum,
    receiptName: String,
    onChangeReceiptName: (String) -> Unit,
    selectedDate: MonthModel,
    setCalendarStatus: (Boolean) -> Unit,
    selectedColor: String?,
    openColorPanel: () -> Unit,
    selectedDays: Int,
    onChangeDayCheckStatus: (Int) -> Unit,
    activityStatus: Boolean,
    onChangeActivity: (Boolean) -> Unit,
) {
    Column(
        modifier = Modifier
            .width(Dimen.templateContentGeneralInfoWidth),
    ) {

        if (windowSizeMode== WindowSizeModeEnum.Desktop){
            Row(
                modifier = Modifier
                    .margin(bottom = Dimen.largePadding),
                verticalAlignment = Alignment.CenterVertically
            )
            {
                TopInfo(
                    windowSizeMode=windowSizeMode,
                    receiptName=receiptName,
                    activityStatus=activityStatus,
                    onChangeReceiptName={
                        onChangeReceiptName(it)
                    },
                    onChangeActivity={
                        onChangeActivity(it)
                    }
                )

            }
        }else{
            Column()
            {
                TopInfo(
                    windowSizeMode=windowSizeMode,
                    receiptName=receiptName,
                    activityStatus=activityStatus,
                    onChangeReceiptName={
                        onChangeReceiptName(it)
                    },
                    onChangeActivity={
                        onChangeActivity(it)
                    }
                )

            }
        }

        if (windowSizeMode== WindowSizeModeEnum.Desktop){
            Row(
                modifier = Modifier
                    .margin(bottom = Dimen.semiLargePadding)
                    .fillMaxWidth(),
                verticalAlignment = Alignment.Bottom
            ){
                RestaurantDateAndColor(
                    windowSizeMode=windowSizeMode,
                    selectedColor=selectedColor,
                    selectedDate=selectedDate,
                    setCalendarStatus={
                        setCalendarStatus(it)
                    },
                    openColorPanel={
                        openColorPanel()
                    },
                )
            }
        }else{
            Column(
                modifier = Modifier
            ){
                RestaurantDateAndColor(
                    windowSizeMode=windowSizeMode,
                    selectedColor=selectedColor,
                    selectedDate=selectedDate,
                    setCalendarStatus={
                        setCalendarStatus(it)
                    },
                    openColorPanel={
                        openColorPanel()
                    },
                )
            }
        }




        SelectDays(
            windowSizeMode = windowSizeMode,
            selectedDaysNumber = selectedDays,
            onChangeDayCheckStatus = {
                onChangeDayCheckStatus(it)
            }
        )


    }


}

@Composable
private fun TopInfo(
    windowSizeMode:WindowSizeModeEnum,
    onChangeReceiptName: (String) -> Unit,
    receiptName: String,
    activityStatus: Boolean,
    onChangeActivity: (Boolean) -> Unit
) {
    CustomEditText(
        modifier = Modifier,
        label = Strings.current().position,
        marginBottom =if (windowSizeMode==WindowSizeModeEnum.Desktop) 0.px
        else Dimen.highLargePadding,
        value = "",
        marginRight = Dimen.largePadding,
        isDecimal = true,
        width = Dimen.semiSmallEditTextWidth,
        isOutlinedEditText = true,
        isRequired = false,
        onFocusIn = {},
        onFocusOut = {
            onChangeReceiptName(it)
        },
        onInputChange = {it, validation ->

        },
    )

    CustomEditText(
        modifier = Modifier,
        label = Strings.current().name,
        value = receiptName,
        marginBottom = 0.px,
        width = Dimen.semiLargeEditTextWidth,
        marginRight = Dimen.normalPadding,
        hint = "",
        isOutlinedEditText = true,
        onFocusIn = {},
        onFocusOut = {
            onChangeReceiptName(it)
        },
        onInputChange = {it, validation ->

        },
    )

    CheckboxComponent(
        modifier = Modifier
            .margin(top = Dimen.normalPadding),
        checkStatus = activityStatus,
        title = Strings.current().activate,
        onChecked = { onChangeActivity(true) },
        onUnChecked = { onChangeActivity(false) },
    )
}

@Composable
private fun RestaurantDateAndColor(
    windowSizeMode: WindowSizeModeEnum,
    selectedDate: MonthModel,
    setCalendarStatus: (Boolean) -> Unit,
    openColorPanel: () -> Unit,
    selectedColor: String?
) {
    //            TODO(this shops data must be replaced with real data)
    val data = listOf<String>(
        "<All shops>",
        "Item 1",
        "Item 2",
        "Item 3",
    )

    DropDownItem(
        modifier = Modifier
            .thenIf(
                windowSizeMode== WindowSizeModeEnum.Desktop,
                Modifier.
                margin(right = Dimen.largePadding)
            )
        ,
        options = data,
        itemWidth = Dimen.mediumEditTextWidth,
        selectedItem = data.getOrNull(0),
        label = Strings.current().shopsExclusiveTemplate,
        displayText = {
            it.toString()
        },
        onOptionClick = {

        }

    )

    Row(
        verticalAlignment = Alignment.Bottom,
        modifier = Modifier
            .thenIf(
                windowSizeMode!= WindowSizeModeEnum.Desktop,
                Modifier.margin(topBottom = Dimen.normalPadding)
            )
    )
    {
        CalendarBox(
            modifier = Modifier,
            selectedDate = selectedDate,
            label = Strings.current().changesValidFrom,
            onClick = {
                setCalendarStatus(true)
            }
        )


        PaintIcon(
            modifier = Modifier
                .margin(left = Dimen.largePadding),
            selectedColor= selectedColor,
            onPaintIconClick = {
                openColorPanel()
            }

        ) 

    }
}


